import { motion } from "framer-motion";
import { Medal } from "lucide-react";

export default function VeteranStory() {
  return (
    <section data-testid="veteran-story" className="border-t border-[#C9A227]/20 bg-[#0D0D12] px-6 py-20 md:px-12">
      <div className="mx-auto max-w-[900px] text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#C9A227]/15"
        >
          <Medal size={28} className="text-[#C9A227]" />
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-6 font-display text-3xl uppercase tracking-tight text-white sm:text-4xl"
        >
          Proudly Veteran-Owned
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-6 text-base leading-relaxed text-white/60 md:text-lg"
        >
          Delta DL Enterprise, LLC was founded by Dr. Dennis Louden, a proud veteran whose service
          instilled the discipline, integrity, and commitment that shape everything we do. The same
          dedication that served our country now serves our students, readers, and collectors —
          every lesson taught, every book written, and every canvas created carries that standard
          of excellence. When you learn with us, you learn from someone who has never accepted
          anything less than his best — and will never accept less than yours.
        </motion.p>
      </div>
    </section>
  );
}
